import { useGetOutreachScheduleQuery } from '@/api/ariadne/__generated_types__/apollo';
import useRegion from '@/utils/hooks/useRegion';
import React from 'react';
import { Panel, Placeholder } from 'rsuite';
import { VIOLATION_TYPE_TO_USER_STRING_MAP } from '../violations-table/constants';

export const OutreachLetters: React.FC = () => {
  const { region } = useRegion();

  const { data, loading } = useGetOutreachScheduleQuery({
    variables: {
      regionId: region,
    },
  });

  if (loading) {
    return (
      <Panel className="mb-5 rounded-lg shadow-md" header="Outreach Letters">
        <Placeholder.Paragraph rows={3} />
      </Panel>
    );
  }

  if (
    !data ||
    !data.getOutreachSchedule ||
    // if nextRunTime is null, it means the outreach letters are not scheduled according to graphql doc
    !data.getOutreachSchedule.nextRunTime
  ) {
    return null;
  }

  return (
    <Panel className="mb-5 rounded-lg shadow-md" header="Outreach Letters">
      <div className="flex items-start mb-5">
        <div className="flex items-center justify-center min-w-6 min-h-6 rounded-full bg-black text-white font-bold mr-2.5">
          !
        </div>
        <div className="text-base leading-normal">
          The next Outreach Letter run for this jurisdiction will be printed on{' '}
          {data.getOutreachSchedule?.nextRunTime}.
        </div>
      </div>
      <div className="ml-8">
        {data.getOutreachSchedule.violationOutreachList.map((violation) => (
          <div key={violation.violationType} className="my-4 flex items-center">
            <div className="w-2 h-2 rounded-full border border-solid border-gray-300 mr-2.5"></div>
            <div className="text-base">
              {VIOLATION_TYPE_TO_USER_STRING_MAP[violation.violationType] ||
                violation.violationType}
            </div>
          </div>
        ))}
      </div>
    </Panel>
  );
};

export default OutreachLetters;
